import React from 'react';
import {
  AttachmentButton,
  Drawer,
  ErrorHandler,
  FileViewer,
  Link,
} from '@common/components';
import { ApprovalsChainByIdQuery } from '@approvals/graphql/queries';
import { useQuery } from '@common/hooks';
import { ApprovalChainActionButtons } from '@approvals/components';
import { buildDialogUrl } from '@common/services';

type Props = {
  open: boolean;
  onClose: () => void;
  approvalChainId?: string;
};

export const ApprovalChainsAttachmentsDrawer = ({
  open,
  onClose,
  approvalChainId,
}: Props) => {
  const { loading, error, data } = useQuery(ApprovalsChainByIdQuery, {
    variables: { id: approvalChainId || '' },
    skip: !approvalChainId,
  });

  if (error) {
    return (
      <ErrorHandler
        error={error}
        log="ApprovalsConfigDrawer"
        messageType="contextual"
      />
    );
  }

  const approvalDocument = data?.approvalChainById?.approvalDocument;
  const source = approvalDocument
    ? [
        {
          id: approvalDocument.id,
          name: approvalDocument.filename,
          url: approvalDocument.downloadUrl,
          uploadedAt: approvalDocument.createdAt,
        },
      ]
    : [];

  const actionsFooter = data && (
    <ApprovalChainActionButtons
      approvalChainStepId={data.approvalChainById?.currentStep?.id}
      approveButtonText="Approve"
      rejectionDrawerTitle="Reject"
      onCompleted={onClose}
    />
  );

  return (
    <Drawer
      size="lg"
      open={open}
      onClose={onClose}
      loading={loading}
      footer={actionsFooter}
      title="Approval Documents"
      className="approvals-attachments-drawer"
    >
      <FileViewer source={source} />
    </Drawer>
  );
};

export function ApprovalChainsAttachmentsDrawerTrigger({
  approvalDocumentFilename,
  approvalChainId,
}: {
  approvalDocumentFilename: string;
  approvalChainId: string;
}) {
  const viewDrawerUrl = buildDialogUrl('approvals-attachments-drawer', {
    props: {
      approvalChainId: approvalChainId,
    },
  });

  return (
    <Link to={viewDrawerUrl}>
      <AttachmentButton size="large">
        {approvalDocumentFilename}
      </AttachmentButton>
    </Link>
  );
}
